"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserOptionParser = void 0;
const util_1 = require("@app/util");
class UserOptionParser {
    userOptions;
    constructor(userOptions) {
        this.userOptions = userOptions;
    }
    getOption(key) {
        const option = this.userOptions?.find((opt) => opt.key === key);
        return option;
    }
    getBoolean(key) {
        const value = this.getOption(key)?.value;
        return value === 'true' ? true : value === 'false' ? false : undefined;
    }
    getNumber(key) {
        const value = this.getOption(key)?.value;
        const _number = Number(value);
        return Number.isNaN(_number) ? undefined : _number;
    }
    getString(key) {
        const value = this.getOption(key)?.value;
        return value;
    }
    getEnum(key, enumObj) {
        const value = this.getOption(key)?.value;
        return (0, util_1.isDefined)(value) && Object.values(enumObj).includes(value)
            ? value
            : undefined;
    }
}
exports.UserOptionParser = UserOptionParser;
